import { HTMLAttributes } from "react";
import { StyledCard } from "./Card.styles";

const Card = ({ children, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return <StyledCard {...props}>{children}</StyledCard>;
};

export default Card;
